import { constructHwtURL } from "../../helpers";
var ComboBoardCardHandler = /** @class */ (function () {
    function ComboBoardCardHandler(props) {
        this.rvt = props.rvt;
        this.comboBoardCardId = props.comboBoardCardId;
        this.locationId = props.locationId;
        this.locationType = props.locationType;
        this.departureDate = props.departureDate;
        this.departureDateType = props.departureDateType;
        this.departurePoints = props.departurePoints;
        this.boards = props.boards;
        this.ratings = props.ratings;
        this.duration = props.duration;
        this.cardLink = props.cardLink;
        this.init();
    }
    ComboBoardCardHandler.prototype.init = function () {
        var _this = this;
        var locationString;
        var tripType;
        this.card = document.querySelector("#".concat(this.comboBoardCardId));
        switch (this.locationType) {
            case "Destination":
                locationString = "destinations";
                tripType = "0";
                break;
            case "Region":
                locationString = "regions";
                tripType = "0";
                break;
            case "Resort":
                locationString = "resorts";
                tripType = "0";
                break;
            case "Accommodation":
                locationString = "fav_accommodations";
                tripType = "0";
                break;
            case "City Destination":
                locationString = "destinations";
                tripType = "1";
                break;
            case "City Region":
                locationString = "regions";
                tripType = "1";
                break;
            case "City Resort":
                locationString = "resorts";
                tripType = "1";
                break;
            case "City Accommodation":
                locationString = "fav_accommodations";
                tripType = "1";
                break;
            default:
                locationString = "";
                break;
        }
        if (!locationString) {
            console.log("Location type not valid, removing combo board card.");
            this.card.remove();
            return;
        }
        else if (!this.locationId) {
            console.log("Location ID not set, removing combo board card.");
            this.card.remove();
            return;
        }
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        myHeaders.append("RequestVerificationToken", this.rvt);
        var requestOptions = {
            method: "GET",
            headers: myHeaders,
        };
        // create querystring base with mandatory filters
        // let queryString: string = `?locationType=${locationString}&locationId=${this.locationId}&amountToDisplay=${this.amountToDisplay}`;
        var queryString = new URLSearchParams({
            "locationType": locationString,
            "locationID": this.locationId.toString()
        });
        // if filters have been given values, append their respective query to the querystring
        if (this.departureDate != "unset") {
            queryString.append("departureDate", this.departureDate);
        }
        if (this.departureDateType != "unset") {
            queryString.append("departureDateType", this.departureDateType);
        }
        // cast departurePoints to an array, iterate through array to create query for querystring
        if (this.departurePoints != "unset" && this.departurePoints != undefined) {
            var departurePoints = this.departurePoints.split(",");
            var count_1 = 0;
            var points_1 = "";
            departurePoints.forEach(function (point) {
                points_1 += "".concat(count_1 > 0 ? "," : "", "\\\"").concat(point, "\\\"");
                count_1++;
            });
            queryString.append("departurePoints", "[".concat(points_1, "]"));
        }
        if (this.boards != "unset") {
            queryString.append("boards", this.boards);
        }
        if (this.ratings != "unset") {
            queryString.append("ratings", this.ratings);
        }
        if (this.duration != "unset") {
            queryString.append("duration", this.duration);
        }
        if (typeof tripType != 'undefined' && tripType != null) {
            queryString.append("tripType", tripType);
        }
        else {
            queryString.append("tripType", "0");
        }
        // Add a check from the client side to stop any requests with missing data hitting the server
        if (locationString && tripType) {
            // get offers by using our own intermediatary API route to hide our API key.
            fetch("/umbraco/api/hwt/getoffer?".concat(queryString.toString()), requestOptions)
                .then(function (response) { return response.text(); })
                .then(function (result) {
                if (!result) {
                    console.log("HWT API returned null or empty response, removing combo board card.");
                    _this.card.remove();
                    return;
                }
                ///////////////////////////
                // FILL IN CARD DATA     //
                ///////////////////////////
                // Get the result of the GraphQL query
                var jsonResult = JSON.parse(result)["data"]["offers"]["result"];
                // remove card if no results
                if (jsonResult.length < 1) {
                    console.log("HWT results empty, removing combo board card.");
                    _this.card.remove();
                    return;
                }
                else {
                    //Sorts results by ascending price order
                    jsonResult.sort(function (a, b) { return a.price_per_person - b.price_per_person; });
                    //We only want the cheapest (first) result
                    jsonResult = jsonResult.slice(0, 1);
                    // There should be only one result - but if there is multiple only the last is used
                    for (var i = 0; i < jsonResult.length; i++) {
                        try {
                            var cardInner = _this.card.querySelector(".js-combo-board-card-inner");
                            ///////////////////////////////////////
                            // REPLACE SKELETON WITH API CONTENT //
                            ///////////////////////////////////////
                            // get and populate title element
                            var hwtResort = jsonResult[i]["accommodation"]["resort"];
                            var hwtDestination = hwtResort["regions"][0]["destinations"][0]["name"];
                            // get and populate the rating element
                            var starElements = cardInner.querySelectorAll(".skeleton-pulse-star");
                            for (var j = 0; j < starElements.length; j++) {
                                if (j < jsonResult[i]["accommodation"]["rating"]) {
                                    starElements[j].classList.replace("skeleton-pulse-star", "fill-selective-yellow");
                                }
                                else {
                                    starElements[j].classList.replace("skeleton-pulse-star", "fill-black/[0.4]");
                                }
                            }
                            // get and populate duration element
                            var durationElement = cardInner.querySelector("#cardDuration");
                            durationElement.innerHTML = "".concat(jsonResult[i]["duration"]);
                            // insert the middle text between duration and departure date
                            var middleText = cardInner.querySelector("#cardNightsText");
                            middleText.innerText = "Nights,";
                            // get and populate date element
                            var dateElement = cardInner.querySelector("#cardDate");
                            dateElement.innerText = "".concat(_this.formatCardDate(jsonResult[i]["flights"][0]["departing"]));
                            // same parent element as duration
                            dateElement.classList.remove("skeleton-pulse");
                            // get and populate board element
                            var boardElement = cardInner.querySelector("#cardBoard");
                            boardElement.innerHTML = "".concat(_this.getBoardString(jsonResult[i]["rooms"][0]["board"]));
                            boardElement.parentElement.classList.remove("skeleton-pulse");
                            // get and populate airport element
                            var airportElement = cardInner.querySelector("#cardAirport");
                            airportElement.innerHTML = "".concat(jsonResult[i]["flights"][0]["departure_airport"]["name"]);
                            airportElement.classList.remove("skeleton-pulse");
                            // get and populate price element
                            var priceElement = cardInner.querySelector("#cardPrice");
                            priceElement.innerText = "".concat(Math.round(jsonResult[i]["price_per_person"]));
                            priceElement.parentElement.parentElement.parentElement.parentElement.parentElement.classList.remove("skeleton-pulse-price");
                            priceElement.parentElement.parentElement.parentElement.classList.remove("flex-grow");
                            priceElement.parentElement.classList.remove("hidden");
                            var sisterText = priceElement.parentElement.parentElement.parentElement.children[0];
                            sisterText.classList.remove("hidden");
                            var search = locationString === 'destinations' || locationString === 'regions' || locationString === 'resorts';
                            if (_this.cardLink !== "unset" || !search) {
                                var fromElement = cardInner.querySelector("#cardFrom");
                                fromElement.remove();
                            }
                            //get and populate button link
                            var fullCardLinkElement = cardInner.querySelector("a");
                            if (_this.cardLink === "unset") {
                                var accommodation = jsonResult[i]["accommodation"]["name"];
                                var accommodationId = jsonResult[i]["accommodation"]["id"];
                                var resort = jsonResult[i]["accommodation"]["resort"]["name"];
                                var region = jsonResult[i]["accommodation"]["resort"]["regions"][0]["name"];
                                var destination = jsonResult[i]["accommodation"]["resort"]["regions"][0]["destinations"][0]["name"];
                                var departing = jsonResult[i]["flights"][0]["departing"];
                                var departurePoint = jsonResult[i]["flights"][0]["departure_airport"]["code"];
                                var duration = jsonResult[i]["duration"];
                                var board = jsonResult[i]["rooms"][0]["board"];
                                var hwtURL = constructHwtURL({
                                    search: search,
                                    locationType: locationString,
                                    locationId: _this.locationId.toString(),
                                    destination: destination,
                                    region: region,
                                    resort: resort,
                                    accommodation: accommodation,
                                    accommodationId: accommodationId,
                                    tripType: tripType,
                                    departureDateType: _this.departureDateType,
                                    departureDate: search ? _this.departureDate : departing,
                                    departurePoints: search ? _this.departurePoints : departurePoint,
                                    duration: search ? _this.duration : duration,
                                    boards: search ? _this.boards : "[".concat(board, "]"),
                                    ratings: _this.ratings
                                });
                                fullCardLinkElement.href = hwtURL.href;
                            }
                            else {
                                fullCardLinkElement.href = _this.cardLink;
                            }
                        }
                        catch (e) {
                            console.log(e);
                        }
                    }
                }
            })
                .catch(function (error) { return console.error(error); });
        }
    };
    ComboBoardCardHandler.prototype.formatCardDate = function (dateString) {
        var date = new Date(dateString);
        var day = date.getDate();
        var month = date.toLocaleString('en-US', { month: 'long' });
        var year = date.getFullYear();
        var formattedDate = "".concat(month, ", ").concat(year);
        return formattedDate;
        function getDateSuffix(day) {
            var lastDigit = day % 10;
            if (lastDigit === 1 && day !== 11) {
                return "st";
            }
            else if (lastDigit === 2 && day !== 12) {
                return "nd";
            }
            else if (lastDigit === 3 && day !== 13) {
                return "rd";
            }
            else {
                return "th";
            }
        }
    };
    ComboBoardCardHandler.prototype.getBoardString = function (boardID) {
        var boardStrings = [
            "Room Only",
            "Self Catering",
            "Bed & Breakfast",
            "Half Board",
            "Full Board",
            "All Inclusive",
        ];
        return boardStrings[boardID];
    };
    return ComboBoardCardHandler;
}());
export { ComboBoardCardHandler };
export default ComboBoardCardHandler;
